import { Zoom } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { MdClose } from "react-icons/md";
import { isSuperAdminLogin } from "../../utils";

export default function CustomAddModal(props) {
  const {
    handleClose,
    title,
    onSubmitConfirm,
    open,
    detailsTitle,
    saveLabel = "Add",
    maxWidth = "sm",
    addThirdBtn = false,
    thirdBtnAction = () => { },
    thirdBtnLabel = "",
    isDetailView = false,
    isScrollable = true,
    buttonCase = "uppercase",
    saveDisabled = false,
    footerExtra = null,
    contentPaddingClass = "!px-2.5 !py-2 sm:!px-3 sm:!py-2",
    saveSpotlight = "save-cargo-btn",
  } = props;

  return (
    <Dialog
      open={open}
      onClose={props.onClose}
      fullWidth
      classes={{
        paper: `rounded-none overflow-hidden border border-slate-200 shadow-2xl ${isSuperAdminLogin() ? "superadmin-dialog" : ""}`,
      }}
      maxWidth={maxWidth}
      TransitionComponent={Zoom}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* Professional Clean Light Header Bar */}
      <div className="flex items-center justify-between w-full px-3 py-1.5 bg-[#f8fafc] border-b border-slate-200">
        <div
          id="alert-dialog-title"
          className="text-slate-900 text-[14px] font-medium tracking-wide"
        >
          {isDetailView ? (detailsTitle || "Details") : title}
        </div>
        <button
          onClick={handleClose}
          className="p-1 text-slate-500 hover:text-slate-900 hover:bg-slate-200/80 transition-colors border-none bg-transparent cursor-pointer flex items-center justify-center"
          title="Close"
        >
          <MdClose size={16} />
        </button>
      </div>

      {/* Content Container with Compact Padding */}
      <DialogContent
        className={`relative scroll-thin ${contentPaddingClass} bg-white`}
        style={{ overflowY: isScrollable ? "auto" : "hidden" }}
      >
        {props.children}
      </DialogContent>

      {/* Professional Footer Bar */}
      {(!isDetailView && !!saveLabel) || addThirdBtn || footerExtra ? (
        <div className="flex items-center justify-end gap-2.5 w-full px-3 py-1.5 bg-slate-50 border-t border-slate-200">
          {footerExtra}
          {!isDetailView && !!saveLabel && (
            <button
              onClick={onSubmitConfirm}
              disabled={saveDisabled}
              className={`disabled:opacity-30 disabled:cursor-not-allowed h-[28px] px-3.5 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#1e2632] border border-[#313C4C] rounded-none shadow-2xs transition-colors ${buttonCase} tracking-wider cursor-pointer`}
              data-spotlight={saveSpotlight}
            >
              {saveLabel}
            </button>
          )}
          {addThirdBtn && (
            <button
              onClick={thirdBtnAction}
              className={`h-[28px] px-3.5 text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-100 border border-slate-300 rounded-none shadow-2xs transition-colors ${buttonCase} tracking-wider cursor-pointer`}
            >
              {thirdBtnLabel}
            </button>
          )}
        </div>
      ) : null}
    </Dialog>
  );
}
